import { Layout } from '@/data/types/Layout';

export const getReturnsPage = (): Layout => ({
	name: 'SingleLayout',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'Returns', id: 'returns-page'}],
		second: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
